/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react"
import { MapContainer, TileLayer, useMap } from "react-leaflet"

const MapController = ({ coordinates, zoom }: { coordinates: [number, number], zoom: number }) => {
    const map = useMap();
    useEffect(() => {
        if (coordinates) {
            map.setView(coordinates, zoom);
        }
    }, [coordinates, map]);
    return null;
};

const Maps = () => {
    const [date, ] = useState();
    const [coordinates, ] = useState<any>([51.505, -0.09]);
    const [zoom, ] = useState<number>(9)

    return (
        <MapContainer center={coordinates} zoom={9} style={{ height: '400px', width: '100%', zIndex: 1 }}>
            <TileLayer url="https://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}" />
            <MapController coordinates={coordinates} zoom={zoom} />
        </MapContainer>
    )
}

export default Maps;
